/* UAT footer SMS visual restyle. Shopify Forms owns phone input, consent and submission. */
(() => {
  'use strict';
  const hostSelector = 'form-embed, shopify-forms-embed';
  const phoneSelector = 'input[type="tel"],input[inputmode="tel"],input[name*="phone" i],input[autocomplete="tel"]';
  const css = [
    ':host { --inline-container-max-width:100% !important; }',
    '[class*="inlineContainer"],[class*="formContainer"] { max-width:100% !important; width:100% !important; background:transparent !important; }',
    '[data-uat-hidden] {display:none !important;}',
    'form[data-uat-sms-form] {position:relative !important; width:100% !important; max-width:100% !important; margin:0 !important; padding:0 !important; background:transparent !important;}',
    '[data-uat-phone-row] {display:flex !important;align-items:center !important;gap:0 !important;box-sizing:border-box !important;width:100% !important;max-width:100% !important;min-width:0 !important;min-height:56px !important;height:56px !important;margin:0 !important;padding:3px 56px 3px 9px !important;border:1px solid #fff !important;border-radius:999px !important;background:#000 !important;box-shadow:none !important;color:#fff !important;}',
    '[data-uat-phone-row] > * {min-width:0 !important;max-width:100% !important;}',
    '[data-uat-phone-row] input:not([type="checkbox"]),[data-uat-phone-row] [role="textbox"] {box-sizing:border-box !important;flex:1 1 0 !important;width:100% !important;min-width:0 !important;min-height:42px !important;height:42px !important;margin:0 !important;padding:0 7px !important;border:0 !important;border-radius:0 !important;outline-offset:0 !important;box-shadow:none !important;background:transparent !important;color:#fff !important;font:inherit !important;font-size:14px !important;}',
    '[data-uat-phone-row] input::placeholder {color:#ddd !important;opacity:1 !important;}',
    '[data-uat-phone-row] button:not([type="submit"]),[data-uat-phone-row] [role="combobox"],[data-uat-phone-row] select {flex:0 0 auto !important;min-width:38px !important;max-width:85px !important;width:auto !important;min-height:40px !important;height:40px !important;margin:0 !important;padding:0 6px !important;border:0 !important;border-radius:999px !important;background:transparent !important;box-shadow:none !important;color:#fff !important;}',
    '[data-uat-phone-row] [class*="country" i] {background:transparent !important;border:0 !important;border-radius:999px !important;box-shadow:none !important;}',
    'input[data-uat-phone-fallback] {box-sizing:border-box !important;width:100% !important;height:56px !important;border:1px solid #fff !important;border-radius:999px !important;background:#000 !important;color:#fff !important;padding:0 56px 0 17px !important;}',
    'form[data-uat-sms-form] button[data-uat-sms-submit] {position:absolute !important;inset:auto 7px auto auto !important;top:var(--uat-sms-top,6px) !important;right:7px !important;display:flex !important;justify-content:center !important;align-items:center !important;width:42px !important;min-width:42px !important;max-width:42px !important;height:42px !important;min-height:42px !important;max-height:42px !important;padding:0 !important;margin:0 !important;transform:none !important;border:0 !important;border-radius:50% !important;background:transparent !important;box-shadow:none !important;color:transparent !important;font-size:0 !important;line-height:1 !important;cursor:pointer !important;z-index:4 !important;}',
    'form[data-uat-sms-form] button[data-uat-sms-submit] > * {display:none !important;}',
    'form[data-uat-sms-form] button[data-uat-sms-submit]::after {content:"→" !important;color:#fff !important;font:400 27px/1 system-ui,sans-serif !important;}',
    'form[data-uat-sms-form] button[data-uat-sms-submit]:disabled::after {opacity:.4 !important;}',
    'form[data-uat-sms-form] button[data-uat-sms-submit]:focus-visible {outline:2px solid white !important;outline-offset:1px !important;}',
    '[data-uat-submit-holder] {height:0 !important;min-height:0 !important;margin:0 !important;padding:0 !important;overflow:visible !important;}',
    'form[data-uat-sms-form] input[type="checkbox"] {accent-color:white !important;width:17px !important;height:17px !important;flex-shrink:0 !important;}',
    'form[data-uat-sms-form] label:has(input[type="checkbox"]) {color:#eee !important;font-size:12px !important;line-height:1.5 !important;}'
  ].join('\n');
  const observers = new WeakSet();
  const resizing = new WeakSet();
  const pending = new WeakSet();
  function positionButton(form,row) {
    if (pending.has(form)) return;
    pending.add(form);
    requestAnimationFrame(() => {
      pending.delete(form);
      if (!form.isConnected || !row.isConnected) return;
      const a=form.getBoundingClientRect(), b=row.getBoundingClientRect();
      if (a.width && b.height) {
        form.style.setProperty('--uat-sms-top',Math.max(0,Math.round(b.top-a.top+(b.height-42)/2))+'px');
      }
    });
  }
  function phoneRow(input,form) {
    let current=input.parentElement, fallback=current;
    for(let n=0;current && current!==form && n<7;n++,current=current.parentElement) {
      if(current.querySelector('input[type="checkbox"]')) break;
      fallback=current;
      if(current.querySelector('button[aria-expanded],button[aria-haspopup],select,[role="combobox"]')) return current;
    }
    return fallback;
  }
  function decorate(shadow) {
    if(!shadow.querySelector('style[data-uat-pill]')) {
      const style=document.createElement('style');
      style.dataset.uatPill='';
      style.textContent=css;
      shadow.appendChild(style);
    }
    shadow.querySelectorAll('h1,h2,h3,h4,p').forEach(el => {
      if (/^(SMS updates|Complete the form to sign up\.?)$/i.test((el.textContent||'').trim())) {
        el.dataset.uatHidden='';
      }
    });
    const input=shadow.querySelector(phoneSelector);
    const form=input && input.closest('form');
    if(!form) return;
    const row=phoneRow(input,form);
    form.dataset.uatSmsForm='';
    if(row && row!==form && !row.querySelector('input[type="checkbox"]')) {
      row.dataset.uatPhoneRow='';
    } else {
      input.dataset.uatPhoneFallback='';
    }
    if(!input.value && !input.placeholder) input.setAttribute('placeholder','Mobile number');
    const submit=form.querySelector('button[type="submit"]') || Array.from(form.querySelectorAll('button')).find(b=>/get text updates|subscribe|sign up/i.test(b.textContent||''));
    if(!submit) return;
    submit.dataset.uatSmsSubmit='';
    if(!submit.getAttribute('aria-label')) submit.setAttribute('aria-label','Get text updates');
    const parent=submit.parentElement;
    if(parent && parent!==form && parent!==row && parent.children.length===1) parent.dataset.uatSubmitHolder='';
    positionButton(form,row||input);
    if(typeof ResizeObserver!=='undefined'&&!resizing.has(form)) {
      resizing.add(form);
      const ro=new ResizeObserver(()=>positionButton(form,row||input));
      ro.observe(form);ro.observe(row||input);
    }
  }
  function scan(root) {
    if(!root || !root.querySelectorAll) return;
    if(root instanceof ShadowRoot) decorate(root);
    root.querySelectorAll(hostSelector).forEach(host => {
      if(host.shadowRoot) scan(host.shadowRoot);
    });
    if(!observers.has(root)) {
      observers.add(root);
      new MutationObserver(()=>scan(root)).observe(root,{childList:true,subtree:true});
    }
  }
  function init() {
    const footer=document.querySelector('.footer-content');
    if(footer) scan(footer);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();